import { fetchEncryptGet } from '../../providers/Fetch';

import {
  AREAS_ERROR,
  AREAS_REQUEST,
  AREAS_SUCCESS,
} from './types';

export const areasError = error => ({
  type: AREAS_ERROR,
  error,
});

export const areasRequest = {
  type: AREAS_REQUEST,
};

export const areasSuccess = data => ({
  type: AREAS_SUCCESS,
  data,
});

export const areasFetch = ({ query }) => async (dispatch) => {
  try {
    const url = 'area';
    dispatch(areasRequest);
    const data = await fetchEncryptGet(url, query);
    if (!(Array.isArray(data) && data.length > 0)) {
      throw new Error('Error occured at fetching area data');
    }
    dispatch(areasSuccess(data));
  } catch (error) {
    dispatch(areasError(error.message));
  }
};
